module.exports = __webpack_public_path__ + "static/media/lipolytics.f70a7e5a.svg";